import { render, staticRenderFns } from "./ExpansionPanelContent.vue?vue&type=template&id=b7bde46c&scoped=true"
import script from "./ExpansionPanelContent.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelContent.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelContent.vue?vue&type=style&index=0&id=b7bde46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bde46c",
  null
  
)

export default component.exports